<template>
    <v-row class="fill-height">
        <v-col cols="11" lg="7" class="fill-height">
            <validation-observer v-slot="{ passes }">
                <v-form @submit.prevent="passes(submit)">
                    <v-card tile flat>
                        <v-card-title>{{ $t('contact.title') }}</v-card-title>
                        <v-card-subtitle>{{ $t('contact.subtitle') }}</v-card-subtitle>
                        <v-card-text>
                            <v-row class="ma-0">
                                <v-col cols="12" class="pa-0">
                                    <validation-provider rules="required" :name="$t('contact.form.name_type')" v-slot="{ errors }">
                                        <v-select
                                                :label="$t('contact.form.label_type')"
                                                :items="types"
                                                v-model="type"
                                                @change="setType"
                                                :error-messages="errors"
                                                :placeholder="$t('contact.form.placeholder_type')"></v-select>
                                    </validation-provider>
                                </v-col>
                                <template v-if="type === 1">
                                    <v-col cols="12" class="pa-0">
                                        <v-row class="ma-0 ">
                                            <v-col cols="4" class="pl-0">
                                                <validation-provider rules="required"
                                                                     :name="$t('contact.form.name_name')" v-slot="{ errors }">
                                                    <v-text-field dense v-model="form.name"
                                                                  :label="$t('contact.form.label_name')"
                                                                  :placeholder="$t('contact.form.placeholder_name')"
                                                                  :error-messages="errors"
                                                                  type="text"></v-text-field>
                                                </validation-provider>
                                            </v-col>
                                            <v-col cols="4" class="pl-0">
                                                <validation-provider rules="required"
                                                                     :name="$t('contact.form.name_surname')" v-slot="{ errors }">
                                                    <v-text-field dense v-model="form.surname"
                                                                  :label="$t('contact.form.label_surname')"
                                                                  :placeholder="$t('contact.form.placeholder_surname')"
                                                                  :error-messages="errors"
                                                                  type="text"></v-text-field>
                                                </validation-provider>
                                            </v-col>
                                            <v-col cols="4" class="pr-0">
                                                <validation-provider rules="required" :name="$t('contact.form.name_email')" v-slot="{ errors }">
                                                    <v-text-field dense v-model="form.email"
                                                                  :label="$t('contact.form.label_email')"
                                                                  :placeholder="$t('contact.form.placeholder_email')"
                                                                  :error-messages="errors"
                                                                  type="email"></v-text-field>
                                                </validation-provider>
                                            </v-col>
                                            <v-col cols="12" class="pl-0 pr-0">
                                                <validation-provider rules="required" :name="$t('contact.form.name_message')" v-slot="{ errors }">
                                                    <v-textarea dense v-model="form.message"
                                                                :label="$t('contact.form.label_message')"
                                                                :placeholder="$t('contact.form.placeholder_message')"
                                                                :error-messages="errors"
                                                    ></v-textarea>
                                                </validation-provider>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                                <template v-else>
                                    <v-col cols="4" class="pl-0">
                                        <validation-provider rules="required"
                                                             :name="$t('contact.form.name_name')" v-slot="{ errors }">
                                            <v-text-field dense v-model="form.name"
                                                          :label="$t('contact.form.label_name')"
                                                          :placeholder="$t('contact.form.placeholder_name')"
                                                          :error-messages="errors"
                                                          type="text"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="4" class="pl-0">
                                        <validation-provider rules="required"
                                                             :name="$t('contact.form.name_surname')" v-slot="{ errors }">
                                            <v-text-field dense v-model="form.surname"
                                                          :label="$t('contact.form.label_surname')"
                                                          :placeholder="$t('contact.form.placeholder_surname')"
                                                          :error-messages="errors"
                                                          type="text"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                    <v-col cols="4" class="pr-0">
                                        <validation-provider rules="required" :name="$t('contact.form.name_email')" v-slot="{ errors }">
                                            <v-text-field dense v-model="form.email"
                                                          :label="$t('contact.form.label_email')"
                                                          :placeholder="$t('contact.form.placeholder_email')"
                                                          :error-messages="errors"
                                                          type="email"></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit"
                                   min-width="30%"
                                   :loading="loading"
                                   color="primary" tile>{{ type === 1 ? $t('contact.button_send') : $t('contact.button_subscribe') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </validation-observer>
        </v-col>
      <template v-if="!$vuetify.breakpoint.mobile">
        <v-col lg="5" class="d-flex justify-center align-center pa-lg-12 nitg__quote-container">
          <quotes-component/>
        </v-col>
      </template>
    </v-row>
</template>

<script>
    export default {
        name: "Contact",
        data() {
            return {
                form: {
                    name: null,
                    surname: null,
                    message: null,
                    email: null
                },
                loading: false,
                type: 1,
            }
        },
        methods: {
            submit() {
                this.loading = true;
                this.checkType();
                this.$http.post(`api/v2/${this.type === 1 ? 'send-message' : 'subscribe'}`, this.form, {
                  headers: {
                    'X-Subscription-Type': 'helpdesk'
                  }
                })
                    .then(() => {
                        this.$worker.resetForm(this.form)
                    })
                    .finally(() => {
                        this.loading = false;
                    })
            },
            checkType() {
                switch (this.type) {
                    case 1:
                        return;
                    case 2:
                        this.form = this.$worker.removeProperties(this.form, 'message');
                        return;
                }
            },
            setType() {
                switch (this.type) {
                    case 1:
                        this.form = this.$worker.addProperties(this.form, 'message');
                        return;
                    case 2:
                        this.form = this.$worker.removeProperties(this.form, 'message');
                        return;
                }
            }
        },
        computed: {
          types () {
            return this.$t('contact.subscribe')
          }
        }
    }
</script>

<style scoped>

</style>
